import { z } from 'zod'

export const roleFormSchema = z.object({
  role_name: z.string().min(1, 'Role name is required'),
  role_description: z.string().min(1, 'Description is required'),
  report_url: z.string(),
})

export type RoleFormValues = z.infer<typeof roleFormSchema>
